import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { USUARIO } from './types';

export const buscarUsuarios = (filtros) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/usuarios/listar`, body, config);
        await dispatch({ type: USUARIO.BUSCAR, payload: res.data.usuarios });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearUsuario = (usuarioData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(usuarioData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/usuarios/crear`, body, config);
        await dispatch({ type: USUARIO.AGREGAR, payload: res.data.usuario });
        await dispatch(setAlert(res.data.msg || 'Usuario creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarUsuario = (usuarioData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(usuarioData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/usuarios/editar`, body, config);
        await dispatch({ type: USUARIO.EDITAR, payload: res.data.usuario });
        await dispatch(setAlert(res.data.msg || 'Usuario editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarUsuario = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/usuarios/eliminar`, body, config);
        await dispatch({ type: USUARIO.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Usuario eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerUsuario = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/usuarios/detalles`, body, config);
        await dispatch({ type: USUARIO.DETALLES, payload: res.data.usuario });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarUsuario = () => dispatch => {
    dispatch({ type: USUARIO.LIMPIAR });
};
